<!-- Dimmed scrim behind the sheet; tapping it dismisses without changing language. -->
<div class="ls-backdrop" (click)="dismiss()"></div>

<div class="ls-sheet" role="dialog" aria-modal="true">
  <div class="ls-grabber" aria-hidden="true"></div>
  <button
    type="button"
    class="ls-close"
    (click)="dismiss()"
    [attr.aria-label]="'menu.language.close' | translate">
    <span class="ls-close-icon" aria-hidden="true"></span>
  </button>

  <div class="ls-title">{{ titleText }}</div>

  <div class="ls-rows">
    <button
      *ngFor="let row of rows"
      type="button"
      class="ls-row"
      [class.ls-row--suggested]="row.variant === 'suggested'"
      [class.ls-row--current]="row.variant === 'current'"
      (click)="select(row.code)">
      <span class="ls-flag" *ngIf="row.showFlag">{{ row.flag }}</span>
      <span class="ls-name">{{ row.nativeName }}</span>
      <span class="ls-tag ls-tag--pill" *ngIf="row.variant === 'suggested'">{{ tagText }}</span>
      <ng-container *ngIf="row.variant === 'current'">
        <span class="ls-tag">{{ tagText }}</span>
        <span class="ls-check" aria-hidden="true">✓</span>
      </ng-container>
    </button>
  </div>
</div>
